import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  SFFeature, UpgradableNumber, 
} from "@dndModels";

import SelectSpecialFeatureTypeBox from "@dndComponents/select/SelectSpecialFeatureTypeBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  obj: SFFeature;
  onChange: (changed: SFFeature) => void; 
  disabled: boolean;
  attached_table?: AttachedTable;
}

export default function SFFeatureInput({
  obj,
  onChange,
  disabled,
  attached_table
}: Props) {
  const [ping, setPing] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectSpecialFeatureTypeBox 
          name="Special Feature Type"
          value={obj.special_feature_type} 
          allowAny
          disabled={disabled}
          onChange={(type: string) => {
            const new_obj = obj;
            new_obj.special_feature_type = type;
            onChange(new_obj);
            setPing(!ping);
            setReloading(true);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        { !reloading &&
          <SelectObjectBox 
            name="Special Feature Options" 
            data_type="special_feature"
            filter={ obj.special_feature_type === "Any" ? {} : { type: obj.special_feature_type } }
            multiple
            values={obj.special_feature_ids} 
            disabled={disabled}
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.special_feature_ids = [...changed];
              onChange(new_obj);
              setPing(!ping);
            }} 
          />
        }
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox 
          name="Choice Count"
          value={obj.count} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = obj;
            new_obj.count = changed.clone();
            onChange(new_obj);
            setPing(!ping);
          }} 
        />
      </Grid>
    </Grid>
  );
}
